const FETCH_BUNDLES_REQUEST = 'FETCH_BUNDLES_REQUEST'
const FETCH_BUNDLES_SUCCESS = 'FETCH_BUNDLES_SUCCESS'
const FETCH_BUNDLES_FAILURE = 'FETCH_BUNDLES_FAILURE'

export { FETCH_BUNDLES_REQUEST, FETCH_BUNDLES_SUCCESS, FETCH_BUNDLES_FAILURE }
